import { useEffect, useState } from "react";

import { haptic, notify } from "../lib/telegram";

interface Props {
  /** Что написано в спокойном состоянии. */
  label: string;
  /** Что написано, когда спрашиваем подтверждение. */
  confirm: string;
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
  onConfirm: () => void | Promise<void>;
}

/** Через сколько «Точно?» само возвращается в спокойное состояние. */
const RESET_MS = 4000;

/**
 * Кнопка необратимого действия: подтверждение вторым тапом.
 *
 * Удаление блока уносит с собой все его тренировки, а промах пальцем в зале —
 * обычное дело. Диалога Telegram не используем: он появился не во всех
 * версиях Bot API, а поведение должно быть одинаковым везде.
 */
export default function ConfirmButton({
  label,
  confirm,
  className,
  ariaLabel,
  disabled,
  onConfirm,
}: Props) {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return;
    const timer = setTimeout(() => setArmed(false), RESET_MS);
    return () => clearTimeout(timer);
  }, [armed]);

  return (
    <button
      className={`${className ?? ""} ${armed ? "is-armed" : ""}`}
      aria-label={ariaLabel ?? label}
      disabled={disabled}
      onClick={() => {
        if (!armed) {
          haptic("medium");
          setArmed(true);
          return;
        }
        notify("warning");
        setArmed(false);
        void onConfirm();
      }}
    >
      {armed ? confirm : label}
    </button>
  );
}
